import InstallPrompt from './InstallPrompt';

export default InstallPrompt;
